import { OrderEs } from "@edp-models/ES/es-order.model";

export interface IOrderEsState {
    orderEs: OrderEs;
    lastAPIError: Error;
}

export const initialOrderKeepState = {
    orderEs: null,
    lastAPIError: null,
};

export const initialOrderEsState: IOrderEsState = {
    ...initialOrderKeepState,
};
